import DataBinder from "../DataBinder.js";
import SwapPage from "../SwapPage.js";
import Items from "../Items.js";


export default class LeaderBoard {

  constructor(app) {
    this.app = app;
    this.items = app.items;
  }

  show(path, model) {

    this.load(app);

    const swapPage = new SwapPage();
    swapPage.swapPage("LeaderBoard");
  }
  populate(model) {
    const dataBinder = new DataBinder();
    dataBinder.populate("LeaderBoard", model);
  }
  load(app) {
    const userdata = app.userdata;
    const gamification = app.gamification;

    const name = userdata.name;
    const leagueRank = userdata.leagueRank;
    const rank = userdata.rank;
    const rating = userdata.rating;
    const id = userdata.id;
    const playerId = userdata.id;
    const avatar = userdata.avatar;


    let model = {
      name,
      id,
      avatar,
      leagueRank,
      rank,
      rating,
      playerId,
      leaderBoard: null
    }

    this.populate(model);

    gamification.GetLeaderboard(null, rank, 500)
      .then((data) => {

        for(let i = 0; i < data.length;i++)
        {
          let player = data[i];
          data[i].isPlayer = (playerId == player.UserId)
        }
        model.leaderBoard = data;
        
        this.populate(model);

        // model.leaderBoard = data;
        // const player = data.find(e => playerId == e.UserId);
        // if (player) player.isPlayer = true;
        // this.populate(model);
      });

  }

}